export class StringTool {

  static capitalizeFirstLetter(string: string) {
    return `${string.charAt(0).toUpperCase()}${string.slice(1)}`;
  }

  static uncapitalizeFirstLetter(string: string) {
    return `${string.charAt(0).toLowerCase()}${string.slice(1)}`;
  }

  static isNotNullOrEmpty(string: string) {
    return string && string !== undefined && string !== '';
  }

  static makeFantasyString(label: string) {
    if (!label || label.length < 50) {
        return label;
    }
    return label.substring(0, 40) + '...' + label.substring(label.length - 10, label.length )
}
}
